// import { moveArrayElement } from '@utils';
import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { commonMessage } from '@locales/intl';
import { showSucsessMessage } from '@services/notifyService';

import useFetch from './useFetch';
import useNotification from './useNotification';
import useTranslate from './useTranslate';

const sortColumn = {
    key: 'sort',
    width: 30,
};

const message = defineMessages({
    updateSuccess: 'Update success!',
    updateError: 'Update error!',
    error: 'The first argument must be an array!',
    updateOrderSuccess: 'Update success!',
    updateOrderError: 'Update error!',
});

function useDragDrop({ data = [], apiConfig, setTableLoading, indexField, getList }) {
    const [sortedData, setSortedData] = useState(
        data.length > 0
            ? [...data].sort((a, b) => {
                const valA = a?.[indexField];
                const valB = b?.[indexField];

                // Nếu là number → sort số
                if (typeof valA === 'number' && typeof valB === 'number') {
                    return valA - valB;
                }

                // Còn lại → sort string (không locale)
                return String(valA ?? '').localeCompare(String(valB ?? ''));
            })
            : [],
    );

    const { execute: executeOrdering } = useFetch(apiConfig);
    const notification = useNotification();
    const translate = useTranslate();
    const onDragEnd = ({ id: dragId }, { id: hoverId }) => {
        if (dragId === hoverId) return;

        const dragIndex = sortedData.findIndex((item) => item.id === dragId);
        const hoverIndex = sortedData.findIndex((item) => item.id === hoverId);

        if (dragIndex === -1 || hoverIndex === -1) return;

        const movedData = moveArrayElement(sortedData, dragIndex, hoverIndex);
        setSortedData([...movedData]);

        updateSingleItem(movedData, dragId);
    };
    const updateSingleItem = (updatedData, movedItemId) => {
        const movedIndex = updatedData.findIndex((item) => item.id === movedItemId);
        if (movedIndex === -1) return;

        const movedItem = updatedData[movedIndex];

        // Xác định rankPre và rankBehind cho item di chuyển
        const rankPre = movedIndex > 0 ? updatedData[movedIndex - 1].rank : null;
        const rankBehind = movedIndex < updatedData.length - 1 ? updatedData[movedIndex + 1].rank : null;

        // Gửi API update
        executeOrdering({
            data: { ...movedItem, rankPre, rankBehind },
            onCompleted: () => {
                showSucsessMessage(translate.formatMessage(message.updateOrderSuccess), translate);
                getList?.(); // Load lại danh sách nếu cần
            },
            onError: (err) => {
                notification({ type: 'error', message: translate.formatMessage(message.updateOrderError) });
            },
        });
    };

    useEffect(() => {
        if (JSON.stringify(data) !== JSON.stringify(sortedData)) {
            setSortedData(data || []);
        }
    }, [data]);

    return { sortedData, onDragEnd, sortColumn };
}

export default useDragDrop;

const moveArrayElement = (arr = [], from, to) => {
    if (!Array.isArray(arr)) throw new Error('The first argument must be an array!');

    const copy = [...arr];
    const [movedItem] = copy.splice(from, 1);
    copy.splice(to, 0, movedItem);

    return copy;
};
